import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init, queryFilterCondition } from './modules'
import Loading from 'components/Loading'

export default function(route) {
  const History = Loadable({
    loader: () => import('./History'),
    render(loaded, props) {
      const Component = connect((state) => ({
        transactionHistoryState: state.transactionHistoryState,
        siteConfig: state.siteConfig
      }), {
        init,
        queryFilterCondition
      })(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/history`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <History {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
